import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getaccountType = createAsyncThunk(
  "accountType/getAccountTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/accountType/getAccountTypeList", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token
        }
      });
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createAccountType = createAsyncThunk(
  "accountType/createAccountType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/accountType/createAccountType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateAccountType = createAsyncThunk(
  "accountType/updateAccountType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/accountType/updateAccountType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

export const deleteAccountType = createAsyncThunk(
  "accountType/deleteAccountType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/accountType/deleteAccountType",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  accountType: [],
  error: null,
  isLoading: false,
  createAccaccountTypeSuccessMessage: null,
  createAccaccountTypeErrorMessage: null,
  updateAccaccountTypeSuccessMessage: null,
  updateAccaccountTypeErrorMessage: null,
  deleteAccountTypeSuccessMessage: null,
  deleteAccountTypeErrorMessage: null,
  searchMessage: null,
}

const accountTypeSlice = createSlice({
  name: "accountType",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createAccaccountTypeSuccessMessage = null;
      state.createAccaccountTypeErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateAccaccountTypeSuccessMessage = null;
      state.updateAccaccountTypeErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteAccountTypeSuccessMessage = null;
      state.deleteAccountTypeErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getaccountType.pending, (state) => {
        state.loading = true;
      })
      .addCase(getaccountType.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMessage = action.payload.result.message;
        }
        state.accountType = action.payload.result.list;
      })

      .addCase(getaccountType.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createAccountType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAccountType.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createAccaccountTypeErrorMessage = action.payload.result.message;
        } else {
          state.createAccaccountTypeSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createAccountType.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateAccountType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAccountType.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateAccaccountTypeSuccessMessage = action.payload.result.message;
        } else {
          state.updateAccaccountTypeErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateAccountType.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteAccountType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAccountType.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteAccountTypeSuccessMessage = action.payload.result.message;
        } else {
          state.deleteAccountTypeErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteAccountType.rejected, (state, action) => {
        state.isLoading = false;
      });

  }
});
export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } = accountTypeSlice.actions;
export default accountTypeSlice.reducer;